'use strict';


import { EnvironmentLayer } from './EnvironmentLayer';
import { BufferGeometry, Points, Vector3 } from 'three';
import { prepareMaterial } from '../../../threejs/autoProjectScript';
import { Loader } from '../../../threejs/loader/Loader';
import { splitArray } from '../../../../functions';
import { LUT } from '../../../post-processing/Passes/LUT';
import { projectMode, threeJsVariables } from '../../../../settings';

export class TreesEnvironment extends EnvironmentLayer{
	constructor () {
		super('Trees');
	}
	
	show() {
		this.group.visible = true;
	}
	
	hide() {
		this.group.visible = false;
	}
	
	loadFromBundle (scene, conf) {
		const config = conf[this.id];
		if (!config || projectMode.AirMode.active) return;
		
		this.settings = config.settings;
		const types = config.types;
		const clusters = config.clusters;
		const loader = new Loader();
		const textureLoader = loader.textureLoader;
		
		clusters.forEach(cluster => {
			cluster.points.forEach(point => {
				this.objects.push(new Vector3().fromArray(point));
			});
		});
		
		const points = splitArray(this.objects,Object.keys(types).length);
		const lut = LUT.getScope('osm-trees');
		
		Object.values(types).forEach((data,index) => {
			const material = prepareMaterial(data.config,textureLoader,'TreeMaterial');
			lut && lut.include(material);
			const geometry = new BufferGeometry().setFromPoints(points[index]);
			const point = new Points(geometry,material);
			this.group.add(point);
		});
	}
	
	set settings(data) {
		if (data) {
			this.group.position.fromArray(data.position);
		}
	}
	
}
